<template>
  <app-drawer
    drawer-ref="user-drawer"
    heading="User details"
    :is-open="userDrawerStore.isOpen"
    :click-outside-allow-classes="['users-table']"
    :is-loading="isLoading"
    @close="close"
  >
    <template #body>
      <div class="space-y-8">
        <user-drawer-card
          :user="user?.data"
          :is-loading="isLoading"
        />
        <user-drawer-roles
          :user="user?.data"
          :user-roles="userRoles?.data"
          :is-loading="isLoading || isUserRolesPending"
          :is-fetching="isUserFetching"
        />
        <user-drawer-security-details
          :user="user?.data"
          :user-roles="userRoles?.data"
          :is-loading="isLoading"
          :is-fetching="isUserFetching"
        />
      </div>
    </template>
  </app-drawer>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useUserDrawerStore } from '@/stores/users';
import { useUserById, useUserRoles } from '@/services/users/queries';
import UserDrawerCard from '@/components/users/UserDrawerCard.vue';
import UserDrawerRoles from '@/components/users/UserDrawerRoles.vue';
import UserDrawerSecurityDetails from '@/components/users/UserDrawerSecurityDetails.vue';

const route = useRoute();
const router = useRouter();
const userDrawerStore = useUserDrawerStore();
const userId = computed(() => userDrawerStore.userId);

const { data: user, isPending: isUserPending, isFetching: isUserFetching } = useUserById(userId);
const { data: userRoles, isPending: isUserRolesPending } = useUserRoles(userId);

const isLoading = computed(() => isUserPending.value || isUserRolesPending.value);

const close = () => {
  switch (route.name) {
    case 'user-details':
      router.replace({ name: 'users' });
      break;
  }
  userDrawerStore.closeDrawer();
};
</script>
